import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "index",
  data: function data() {
    return {
      phone: '',
      //医院电话
      address: '',
      //医院联系地址
      name: '',
      introduction: ''
    };
  },
  created: function created() {
    this.phone = window.g.VUE_APP_PHONE;
    this.address = window.g.VUE_APP_ADDRESS;
    this.name = window.g.VUE_APP_HOSPITALNAME;
    this.introduction = process.env.VUE_APP_INTRODUCTION;
  },
  methods: {
    toUserInfo: function toUserInfo() {
      this.$router.push({
        name: 'userinfo'
      });
    }
  }
};